import styled from 'styled-components';
export var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-1y9gsym-0"
})(["padding:22px 22px 8px;border-top-left-radius:8px;border-top-right-radius:8px;background-color:", ";text-align:left;"], function (_ref) {
  var theme = _ref.theme,
    primaryBackground = _ref.primaryBackground;
  return primaryBackground ? theme.colors.primaryLL : theme.cardsBackgroundColor;
});